import { ImageSplitter } from "react-image-splitter"
import '../splitter/index.css'

const Splitter = () => {
  return (
    <>
      <ImageSplitter
 source={<img src={`${process.env.PUBLIC_URL}/splitter/tiger.jpg`} alt="Tiger" />}
 content={<img src={`${process.env.PUBLIC_URL}/splitter/tiger-b.jpg`} style={{filter:'grayscale(100%)'}}/>}
  startPosition={30}
 />
    </>
  )
}

export default Splitter
